<template>
    <div class="input-with-label">
        <label v-if="props.label || $slots.label" :for="props.forId">
            <slot name="label">{{ props.label }}</slot>
            <span v-if="props.optional" class="optional-label">(optional)</span>
        </label>
        <slot />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
    label?: string;
    forId?: string;
    optional?: boolean;
}>();
</script>

<style lang="scss" scoped>
.input-with-label {
    display: flex;
    flex-direction: column;
    gap: var(--smallSpacing);

    > label {
        font-size: var(--extraSmallFontSize);
        text-transform: uppercase;
        color: var(--neutral600);
        display: inline-flex;
        align-items: center;
        gap: var(--extraSmallSpacing);
        white-space: nowrap;
    }

    .optional-label {
        color: var(--neutral600);
        font-size: 0.85em;
        font-weight: var(--normalFontWeight);
        text-transform: none;
        opacity: 0.8;
    }
}
</style>
